<div class="header">
  <div class="action">
    <div class="close" (click)="close(GeneralConfirmationModalResult.None)">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="modal-header">
  <h3 class="modal-title">{{ data.title }}</h3>
</div>
<div class="modal-body">
  @if (data.message && !data.useInnerHtml) {
    <p [ngClass]="data.textAlign">{{ data.message }}</p>
  }
  @if (data.message && data.useInnerHtml) {
    <p [ngClass]="data.textAlign" [innerHTML]="data.message"></p>
  }
  @if (data.isImage) {
    <img class="image" [src]="data.imageSrc" alt="">
  }
</div>
<div class="modal-footer">
  @if (data.cancelButton) {
    <button (click)="close(GeneralConfirmationModalResult.Cancel)"
      class="button secondary">{{ 'general-confirmation-modal.modal-footer.cancel-button' | translate }}
    </button>
  }

  @if (data.confirmButton) {
    <button (click)="close(GeneralConfirmationModalResult.Confirm)"
      class="button primary">{{ data.confirmButtonText }}
    </button>
  }
  <!--  <button (click)="close(GeneralConfirmationModalResult.Custom)" *ngIf="data.customButton" color="warn"-->
  <!--          mat-raised-button>{{ 'general-confirmation-modal.modal-footer.custom-button' | translate }}-->
<!--  </button>-->
</div>
